export enum BackendInstances {
  TEST_STAGING = 'https://test-staging',
  STAGING = 'https://tablesready-staging.herokuapp.com',
  DOCKMAGIC_PROD = 'https://dockmagic-production.herokuapp.com',
  TABLESREADY_PROD = 'https://tablesready-production.herokuapp.com'
}
